import { TASK_STATUS } from '@/common/constants/constants';

export const TASK_STATUS_LABEL_KEYS = {
  [TASK_STATUS.NEW]: 'New',
  [TASK_STATUS.ONGOING]: 'Ongoing',
  [TASK_STATUS.COMPLETED]: 'Completed',
  [TASK_STATUS.SUSPENDED]: 'Suspended',
  [TASK_STATUS.ON_HOLD]: 'On hold',
  [TASK_STATUS.DEACTIVATED]: 'Deactivated',
};

export const getTaskStatusLabel = (t, status) =>
  t(TASK_STATUS_LABEL_KEYS[status] || status);
